import { Box, Text } from '@hawkins/components';
import { Colors, Dimensions } from '@hawkins/variables';
import styles from './NetflixUHDBanner.module.css';

interface NetflixUHDBannerProps {
  approved: boolean;
}

export const NetflixUHDBanner = ({ approved }: NetflixUHDBannerProps) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    padding={Dimensions.Space10}
    borderRadius={4}
    backgroundColor={approved ? Colors.Green600 : Colors.Red600}
  >
    <Text align="center" className={styles.uhdBannerText}>
      Approved For Netflix UHD: {approved ? 'YES' : 'NO'}
    </Text>
  </Box>
);
